module.exports = __webpack_public_path__ + "static/fondatrice-4da1380f370c0291c77f1620e77e689a.jpg";